import React, { useEffect, useState } from "react";
import 'animate.css';
import "../../chat/animate/slide_top.css"
import "../../chat/animate/slide_in_left.css";
import Rating from "./Rating.js";
import './GoodsMessage.scss';
import productData from '../../../assets/product.json'
const GoodsMessage = ({ content,psychicId }) => {

    const [selectedProduct, setSelectedProduct] = useState(null);

    useEffect(() => {
        //本地映射表
        // 查找匹配的商品
        const product = productData.find(item => item.skuid == String(content));
        setSelectedProduct(product);

    }, []); // 空数组表示这个effect只在组件挂载时执行一次。

    const redirectToGoodsPage = ({ goodsUrl }) => {
        event.preventDefault(); // 阻止默认的链接跳转
        window.open(goodsUrl + "?a_aid=" + psychicId, '_blank');
    };

    // 提取第一个 "Categories" 后的值
    const extractFirstCategory = (categoryString) => {
        const categories = categoryString.split(','); // 以逗号分割字符串
        for (let category of categories) {
            if (category.startsWith('Categories:')) {
                return category.split(':')[1].trim(); // 提取并返回值
            }
        }
        return null; // 如果没有找到
    };

    return (
        <div className="hight_good_div slide-in-left">
            {selectedProduct ? (
                <div className="highgoods_content">
                    <div className="high" onClick={() => redirectToGoodsPage({ goodsUrl: selectedProduct.detail_url, goodsId: selectedProduct.skuid, goodsName: selectedProduct.product_name, categoryName: selectedProduct.product_category, price: selectedProduct.sale_price })}>
                        <div className="high_top">
                            <img className="high_img" src={selectedProduct.product_media} />
                            <div className="high_right">
                                <span className="high_name">{selectedProduct.product_name}</span>
                                <div className="high_rate">
                                    <Rating
                                        rating={selectedProduct.rate}
                                        width={20} />
                                    <span className="tag_name">{extractFirstCategory(selectedProduct.product_category)}</span>
                                </div>
                            </div>
                        </div>
                        <div className="high_price">
                            <div>
                                <span className="current_price">$ {selectedProduct.sale_price}</span>
                                <span className="standard_price">$ {selectedProduct.standard_price}</span>
                            </div>

                            <span className="high_buynow">Check Later</span>
                        </div>
                    </div>
                </div>
            ) : (<p></p>)}
        </div>
    )
}
export default GoodsMessage;